import { render, staticRenderFns } from "./paperEdit.vue?vue&type=template&id=314fd4b0&"
import script from "./paperEdit.vue?vue&type=script&lang=js&"
export * from "./paperEdit.vue?vue&type=script&lang=js&"
import style0 from "./paperEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports